module.exports = __webpack_public_path__ + "img/down.b6834269.png";